import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class ShippingTermsStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
